module.exports = __webpack_public_path__ + "static/img/pic_pico01@2x.701f913.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_pico01@2x.png
// module id = S4c+
// module chunks = 0